import React, { Component } from 'react'
import { connect } from 'react-redux'
import { REST_API } from '../../../actions/constants'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import DashboardTaskModal from '../DashboardTaskModal';
import {BrowserView,MobileView,isBrowser,isMobile} from 'react-device-detect';


class CompletedSummary extends Component {

  state = {
    tasksLoaded: false,
    queuedTasks: [],
    taskType: 'completed', //processed
    taskStatus: 'completed' //processing
  }

  AbortController = new window.AbortController()

  componentDidMount() {
    this.fetchTaskData();
  }

  componentWillUnmount() {
    this.AbortController.abort()
  }

  capitalize = (s) => {
    return s[0].toUpperCase() + s.slice(1);
  }


  /**
	 * @function 		: Only fetch 5 properties fomr the messagequeue endpoint and then update the component state
	 * @params 			: ['id', 'name', 'description', 'topic', 'create_at']
	 * @taskTypes 	: ['compeleted tasks', 'Still processing tasks', 'failed tasks']
	 */
  fetchTaskData = () => {
    const token = this.props.auth.access_token

    fetch(`
            ${REST_API}/analytics/messagequeues?category=summary/tasks&status=${this.state.taskStatus}&access_token=${token}
					`, { signal: this.AbortController.signal })

      .then(res => res.json())
      .then(data => {

        if (data.messagequeues) {

          this.setState({
            tasksLoaded: true,
            queuedTasks: data.messagequeues
          });
        }
      }) // End of queued tasks api call

  }

  renderTasksData = () => {

    if (this.state.queuedTasks.length) {

      return this.state.queuedTasks.map((item, index) => {
        console.log("item",item)
        return (
          <Link
            key={index}
            to={"/message-queues?" + "task=" + item.name + "&status=" + this.state.taskType + "&task_id=" + item.task_id}
            className="list-group-item task-item task-row-striped"
          >
            <div className="row">
              <div className="col-md-6 col-sm-6 col-xs-6" style={{ padding: "2px" }}>{item.name}</div>
              <div className="col-md-1 col-sm-6 col-xs-6 text-md-right">{item.count}</div>
            </div>
          </Link>
        )
      })
    }

    return <div className="no-data">No Data</div>
  }


  render() {
    let mobileStyle ={
      top: "49px",
      overflowY: "scroll",
      overflowX: "hidden"
    }
    if (this.state.tasksLoaded) {
      return (
        <div style={{ margin: 0 }}>

          <div className="component-title list-group" id="working-area">
            <div className="list-group-item list-group-item-action gradient-background">
              <div className="" id="endpoint-label-wrapper">
                <div className="float-left breadcrumbs">
                  <div className="">
                    <p style={{ "margin-top": "3px" }}><a href="/"><i className="fas fa-th"></i></a><span><i className="fas fa-arrow-right"></i><a href="/tasks/completed">Completed Tasks</a></span></p>
                  </div>
                </div>
                <div className=""></div>
              </div>
            </div>
            {/* <div id="working-area-content" className="fade-enter-done" style={{ top: "49px", overflowY: "scroll"}}> */}
            <div id="working-area-content" className="fade-enter-done" style={isMobile? mobileStyle: {top: "49px", overflowY: "scroll"}}>
              <div className="fade-enter-done" style={{ "min-width": "940px" }}>
                <div className="working-view1 mb-5 xs-5" style={{ "min-width": "940px" }}>
                  <div className="task-header row" style={{ margin: 0 }}>
                    <div className="col-md-6 col-sm-6 col-xs-6" style={{ padding: "2px" }}>Name</div>
                    <div className="col-md-1 col-sm-6 col-xs-6 text-md-right">Count</div>
                    {/* <div className="col-md-1 col-sm-1 col-xs-1" style={{ padding: "2px" }}>Name</div>
                    <div className="col-md-1 col-sm-1 col-xs-1 text-md-right">Count</div> */}
                  </div>
                  {this.renderTasksData()}
                </div>
              </div>
            </div>
          </div>

        </div>
      )
    }

    return (
      <div className={"task-section " + this.state.taskType + "-task"}>
        <i className="fa fa-cog fa-lg fa-spin"></i> <span>Loading Tasks</span>
      </div>
    )

  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth
  }
}

export default withRouter(connect(mapStateToProps)(CompletedSummary))



// WEBPACK FOOTER //
// ./src/components/dashboard/taskviewsection/CompletedSummary.js